export default __webpack_public_path__ + "static/defi-safety-score-cbe63978cd2436abb4d6600ddf1ec893.svg";